export const environment = {
  production: true,
  apiUrl: 'https://my-api.softprocorp.com/api',
  webUrl: 'https://my.softprocorp.com',
  oktaBaseUrl: 'https://softpro.okta.com',
  oktaAuthUrl: '/oauth2/aus2ahhrc8nJCm2Al4x7',
  oktaWebfingerUrl: '/.well-known/webfinger?resource=okta:acct:',
  oktaClientId: '0oapf48lcjeRi9Rc24x7',
  oktaRedirectUri: '/login/callback',
  loginReturnUri: '/login',
  signinReturnUri: '/signin',
  ahaUrl: 'https://softpro.ideas.aha.io',
  oktaIdp: '0oax03swon1Tgqj8H4x7',
  csp: '',
};
